import { useAuthContext } from '@/app/providers/AuthProvider';

/**
 * Main auth hook. Use in pages and RequireAuth.
 * Exposes: user (with roles?: string[]), isAuthenticated, isLoading, login, logout, hasRole, hasAnyRole.
 */
export function useAuth() {
  return useAuthContext();
}
